import { TreatmentDesignRevisionLiability } from '../treatment-design-revision-judgement';

/**
 * A liability a design revision can be attributed to.
 *
 * The seeded rows mirror `TreatmentDesignRevisionLiability`; rows QC adds have ids outside that enum,
 * so never treat an unrecognised id as invalid — render `displayName` and move on.
 */
export interface RevisionLiability {
    readonly id: TreatmentDesignRevisionLiability;
    /** Stable identifier: the enum member name for seeded rows, `Custom{id}` for QC-created ones. */
    readonly name: string;
    /** What the lab reads, e.g. 设计师责任. */
    readonly displayName: string;
    readonly displayOrder: number;
    /** False once retired: still resolves on old data, no longer offered for new. */
    readonly isActive: boolean;
    /** The judging flow branches on this one, so it cannot be retired. */
    readonly isSystem: boolean;
    /** Active reasons filed under it; non-zero blocks retiring. */
    readonly activeReasonCount: number;
    /** Every reason filed under it, retired ones included. */
    readonly reasonCount: number;
    /** Judgements already attributed to it; why it can never be deleted. */
    readonly judgementCount: number;
    readonly modifiedDate: string;
    readonly modifiedBy?: string | null;
}
